import { useEffect } from "react";
//plaatsen in Webpage.components: 
// import { WeekendVanDeKlant } from "./WeekendVanDeKlant";
// en verder in het doc <WeekendVanDeKlant GlobalScore={GlobalScore} /> gebruiken


// Define the component
export const WeekendVanDeKlant = ({ GlobalScore }) => {
  const saveScoreToFirebase = async () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hour = String(now.getHours()).padStart(2, '0');

    // Build the Firebase REST API URL using the date and time
    const firebaseUrl = `https://karrewietweer.firebaseio.com/kuleuven/${year}/${month}/${day}/${hour}.json`;

    // The data to be saved to Firebase
    const data = {
      score: GlobalScore,
      timestamp: now.toISOString(),
    };

    try {
      // Make the POST request to add the score to Firebase
      const response = await fetch(firebaseUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error("Failed to save score to Firebase");
      }

      console.log("Score saved successfully to Firebase!");
    } catch (error) {
      console.error("Error saving score to Firebase:", error);
    }
  };

  const checkUrlParameters = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const quiz = urlParams.get("quiz");
    const shape = urlParams.get("shape");

    // Check if the URL contains the specific quiz and shape parameters
    if (quiz === "ku-leuven" && shape === "quiz_reeks") {
      console.log("URL parameters are correct!");
      return true;
    } else {
      console.warn("URL parameters are missing or incorrect.");
      return false;
    }
  };

  useEffect(() => {
    if (GlobalScore > 0 && checkUrlParameters()) {
      saveScoreToFirebase();
    }
  }, [GlobalScore]);

  return null; // No visible UI, just saving to the database
};
